import axios from "axios";
import { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import "../../workers/WorkerCategories.css"
import "../../doorstepServices/DoorstepServices.css";
import { ITransactions } from "src/helper/interfaces";
import Cookies from "js-cookie";
import profileIcon from "../../../../assets/img/icons/vecteezy_man-empty-avatar-vector-photo-placeholder-for-social_36594092.jpg"
import { formatCategory, formatDiffrentDate } from "src/utils/normalFuntions";
import { Link, useParams } from "react-router-dom";
import moment from "moment";


export const getTransactionById = async (
   token: string,
   id: string
) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/transaction/${id}`, {
      headers: {
         "x-access-token": token
      }
   })
};

const TransactionDetailsPage = () => {

   const { id } = useParams();
   const Token = Cookies.get('token');
   const [selectedTransaction, setSelectedTransaction] = useState<ITransactions>();

   useEffect(() => {
      if (Token) {

         getTransactionById(Token as string, id as string).then((res) => {
            // console.log(res?.data?.data?.data);
            // console.log(res?.data)
            if (res?.data?.status_code === 200) {
               // console.log(res?.data)
               setSelectedTransaction(res?.data?.data);

            }
         })
            .catch((err: any) => {
               console.log(err)
            })
      }
   }, [id])


   const membershipExpiry = formatDiffrentDate(selectedTransaction?.membershipAndSubscriptionsDetails?.membership_validity as string)

   const isMembershipOrSubscription = ["membership", "subscription"].includes(selectedTransaction?.order_type as string);
   const checkWorker = ["membership", "subscription", "wallet_withdraw", "doorstep_service"];
   const isWorker = checkWorker?.includes(selectedTransaction?.order_type as string);
   const isDate = moment(selectedTransaction?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY hh:mm A');;
   return (
      <MainLayout

         showAllFilters={true}
      >

         <div className="mt-3 mb-3">

            <div className="category-main me-2 p-3 p-md-4"  >
               <div className="row">

                  <div className="col-xxl-3 col-xl-4 p-2 theiaStickySidebar">

                     <div className="theiaStickySidebar"
                        style={{ paddingTop: " 0px", paddingBottom: "1px", position: "static", transform: 'none', top: "0px", left: "276px" }}>
                        <div className="card border-white ">
                           <div className="card-header border-1 " style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                              <div className="d-flex align-items-center flex-wrap row-gap-3">
                                 <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                    {
                                       isWorker ?
                                          <img
                                             src={
                                                selectedTransaction?.workerDetails?.profile_pic
                                                   ? typeof selectedTransaction?.workerDetails?.profile_pic === 'string'
                                                      ? selectedTransaction?.workerDetails?.profile_pic
                                                      : URL.createObjectURL(selectedTransaction?.workerDetails?.profile_pic)
                                                   : profileIcon
                                             }

                                          /> :
                                          <img
                                             src={
                                                selectedTransaction?.userDetails?.profile_pic
                                                   ? typeof selectedTransaction?.userDetails?.profile_pic === 'string'
                                                      ? selectedTransaction?.userDetails?.profile_pic
                                                      : URL.createObjectURL(selectedTransaction?.userDetails?.profile_pic)
                                                   : profileIcon
                                             }

                                          />
                                    }

                                 </div>
                                 <div className="d-flex flex-column">
                                    <h5 className="mb-1 text-start">{selectedTransaction?.order_type ?? "NA"} </h5>
                                    <span className="text-start  mb-1">{selectedTransaction?.unique_id ?? "NA"}</span>
                                    <span className="text-start">Created At: {isDate ?? "NA"} </span>
                                 </div>
                              </div>
                           </div>
                           <div className="card-body text-start">
                              <h5 className="mb-3">Transaction Details</h5>
                              <dl className="row mb-0">
                                 {/* Worker Type */}
                                 <dt className="col-5 fw-medium text-dark mb-3">Transaction Id :</dt>
                                 <dd className="col-7 mb-3"> {selectedTransaction?._id}</dd>
                                 <dt className="col-5 fw-medium text-dark mb-3">Customer Type :</dt>
                                 <dd className="col-7 mb-3">   {selectedTransaction?.customer_type}</dd>

                                 <dt className="col-5 fw-medium text-dark mb-3">Order Type :</dt>
                                 <dd className="col-7 mb-3"> {formatCategory(selectedTransaction?.order_type as string)}</dd>


                                 <dt className="col-5 fw-medium text-dark mb-3">Order Id :</dt>
                                 <dd className="col-7 mb-3">
                                    {selectedTransaction?.order_id}

                                 </dd>
                                 {
                                    selectedTransaction?.order_name !== "membership" ?
                                       (
                                          <>
                                             <dt className="col-5 fw-medium text-dark mb-3">Order name :</dt>
                                             <dd className="col-7 mb-3">
                                                {selectedTransaction?.order_name}

                                             </dd>
                                          </>
                                       )
                                       : ""
                                 }

                                 <dt className="col-5 fw-medium text-dark mb-3"> {selectedTransaction?.order_type === "doorstep_service" ? "Paid to Worker" : "Amount Paid"}  :</dt>
                                 <dd className="col-7 mb-3">&#8377; {selectedTransaction?.payment_amount}</dd>
                                 <dt className="col-5 fw-medium text-dark mb-3">Payement Order Id :</dt>
                                 <dd className="col-7 mb-3">{selectedTransaction?.payment_id}</dd>

                                 {
                                    selectedTransaction?.membershipAndSubscriptionsDetails?.salesCommitionL1 ?
                                       <>
                                          <dt className="col-md-5 fw-medium text-dark mb-3">{`Sales Comm. L1 (${selectedTransaction?.membershipAndSubscriptionsDetails?.salesL1CommPercent}%) `} :</dt>
                                          <dd className="col-md-7 mb-3">&#8377; {selectedTransaction?.membershipAndSubscriptionsDetails?.salesCommitionL1 ?? 0}</dd></>
                                       : ""
                                 }
                                 {
                                    selectedTransaction?.membershipAndSubscriptionsDetails?.salesCommitionL2 ?
                                       <>
                                          <dt className="col-md-5 fw-medium text-dark mb-3">{`Sales Comm. L2 (${selectedTransaction?.membershipAndSubscriptionsDetails?.salesL2CommPercent}%) `} :</dt>
                                          <dd className="col-md-7 mb-3">&#8377; {selectedTransaction?.membershipAndSubscriptionsDetails?.salesCommitionL2 ?? 0}</dd></>
                                       : ""
                                 }
                                 {
                                    selectedTransaction?.membershipAndSubscriptionsDetails?.is_referralCode_used ?
                                       <>
                                          <dt className="col-md-5 fw-medium text-dark mb-3">Yows Comm. :</dt>
                                          <dd className="col-md-7 mb-3">&#8377; {selectedTransaction?.membershipAndSubscriptionsDetails?.yowsComm ?? 0}
                                          </dd> <dt className="col-md-5 fw-medium text-dark mb-3">Comm. Excl. GST :</dt>
                                          <dd className="col-md-7 mb-3">&#8377; {selectedTransaction?.membershipAndSubscriptionsDetails?.amountExcludingGST ?? 0}</dd>
                                          <dt className="col-md-5 fw-medium text-dark mb-3">GST Amount :</dt>
                                          <dd className="col-md-7 mb-3">&#8377; {selectedTransaction?.membershipAndSubscriptionsDetails?.gstOnYowsComm ?? 0}
                                          </dd>
                                       </> : ''
                                 }

                              </dl>
                           </div>
                        </div>
                        {
                           selectedTransaction?.order_type === "doorstep_service" ?
                              <div className="card border-white ">
                                 <div className="card-body text-start">
                                    <h5 className="mb-3">Billing Details</h5>
                                    {
                                       selectedTransaction?.order_type === "doorstep_service" ?
                                          <dl className="row mb-0">
                                             {/* Worker Type */}
                                             <dt className="col-7 fw-medium text-dark mb-3">Service Charges :</dt>
                                             <dd className="col-5 mb-3">  &#8377; {
                                                (selectedTransaction?.doorstepOrderDetails?.billing_details?.service_charges ?? 0) * (selectedTransaction?.doorstepOrderDetails?.service_count ?? 1) || 0
                                             }</dd>

                                             {
                                                selectedTransaction?.doorstepOrderDetails?.billing_details?.promo_code?.length ?
                                                   <>
                                                      <dt className="col-7 fw-medium text-dark mb-3">Promo Code :</dt>
                                                      <dd className="col-5 mb-3"> {selectedTransaction?.doorstepOrderDetails?.billing_details?.promo_code}</dd>

                                                      <dt className="col-7 fw-medium text-dark mb-3">Discounted Amount :</dt>
                                                      <dd className="col-5 mb-3"> &#8377; {selectedTransaction?.doorstepOrderDetails?.billing_details?.promo_amount}</dd>

                                                      <dt className="col-7 fw-medium text-dark mb-3">Sub Total :</dt>
                                                      <dd className="col-5 mb-3"> &#8377; {
                                                         ((selectedTransaction?.doorstepOrderDetails?.billing_details?.service_charges || 0) * (selectedTransaction?.doorstepOrderDetails?.service_count || 0) -
                                                            (selectedTransaction?.doorstepOrderDetails?.billing_details?.promo_amount ? selectedTransaction?.doorstepOrderDetails?.billing_details?.promo_amount : 0))}</dd>
                                                   </> : ''
                                             }

                                             <dt className="col-7 fw-medium text-dark mb-3">Tax Amount (GST)</dt>
                                             <dd className="col-5 mb-3">     &#8377; {selectedTransaction?.doorstepOrderDetails?.billing_details?.tax}</dd>

                                             <dt className="col-7 fw-medium text-dark mb-3">Paid Amount :</dt>
                                             <dd className="col-5 mb-3">&#8377; {selectedTransaction?.doorstepOrderDetails?.billing_details?.total_amount}</dd>

                                             <span className="text-start text-dark font-weight-normal">
                                                Yows Commision Details
                                             </span>

                                             <dt className="col-7 fw-medium text-dark mb-3">Commision (Inc. gst) :</dt>
                                             <dd className="col-5 mb-3">
                                                &#8377; {selectedTransaction?.doorstepOrderDetails?.billing_details?.yows_comm_inc_gst}
                                             </dd>

                                             <dt className="col-7 fw-medium text-dark mb-3">Commision (Exc. gst) :</dt>
                                             <dd className="col-5 mb-3">
                                                &#8377; {selectedTransaction?.doorstepOrderDetails?.billing_details?.yows_comm_exc_gst}
                                             </dd>

                                             <dt className="col-7 fw-medium text-dark mb-3">Gst Amount :</dt>
                                             <dd className="col-5 mb-3">&#8377; {selectedTransaction?.doorstepOrderDetails?.billing_details?.gst_on_yows_comm}</dd>

                                             <span className="text-start text-dark font-weight-normal">
                                                Worker Commision Details
                                             </span>

                                             <dt className="col-7 fw-medium text-dark mb-3">Commision (Inc. gst) :</dt>
                                             <dd className="col-5 mb-3"> &#8377; {selectedTransaction?.doorstepOrderDetails?.billing_details?.worker_comm}
                                             </dd>
                                             <dt className="col-7 fw-medium text-dark mb-3">Gst Amount :</dt>
                                             <dd className="col-5 mb-3"> &#8377; {selectedTransaction?.doorstepOrderDetails?.billing_details?.gst_on_worker_comm}
                                             </dd>
                                             <dt className="col-7 fw-medium text-dark mb-3">Gst Tcs :</dt>
                                             <dd className="col-5 mb-3"> &#8377; {selectedTransaction?.doorstepOrderDetails?.billing_details?.tcs_amt}
                                             </dd>


                                          </dl>
                                          : ""
                                    }

                                 </div>
                              </div> : ""
                        }


                     </div>
                  </div>
                  <div className="col-xxl-9 col-xl-8 p-2">
                     <div className="row ">
                        {
                           selectedTransaction?.order_type !== "wallet_withdraw" ?
                              <div className="col-md-12 p-2">
                                 <div className="card mb-0">
                                    <div className="card-header" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                       <h5 className="text-start mb-0" >
                                          {
                                             selectedTransaction?.order_type === "doorstep_service" ? "Doorstep Order Details" :
                                                selectedTransaction?.order_type === "requirement" ? "Requirement Details" :
                                                   selectedTransaction?.order_type === "membership" ? "Membership Details" :
                                                      selectedTransaction?.order_type === "wallet_withdraw" ? "" : "Subscription Details"
                                          }
                                       </h5>
                                    </div>
                                    <div className="card-body">
                                       <div className="border rounded p-3 pb-0">
                                          <div className="row">
                                             {
                                                selectedTransaction?.order_type === "doorstep_service" && (
                                                   <>
                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Order Id</p>
                                                            <p className="text-start ">{selectedTransaction?.doorstepOrderDetails?._id} </p>
                                                         </div>
                                                      </div>
                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Service Id:</p>
                                                            <p className="text-start ">{selectedTransaction?.doorstepOrderDetails?.service_id} </p>
                                                         </div>
                                                      </div>
                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Order Name :</p>
                                                            <p className="text-start ">{selectedTransaction?.doorstepOrderDetails?.service_title} </p>
                                                         </div>
                                                      </div>
                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Order Date:</p>
                                                            <p className="text-start ">{formatDiffrentDate(selectedTransaction?.createdAt as string)?.formattedDate} </p>
                                                         </div>
                                                      </div>
                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Order Type:</p>
                                                            <p className="text-start ">{formatCategory(selectedTransaction?.doorstepOrderDetails?.order_type as string)} </p>
                                                         </div>
                                                      </div>
                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Order Category:</p>
                                                            <p className="text-start ">{selectedTransaction?.doorstepOrderDetails?.service_category} </p>
                                                         </div>
                                                      </div>
                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Order Count:</p>
                                                            <p className="text-start ">{selectedTransaction?.doorstepOrderDetails?.service_count} </p>
                                                         </div>
                                                      </div>
                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Order Status:</p>
                                                            <p className="text-start ">{formatCategory(selectedTransaction?.doorstepOrderDetails?.status as string)} </p>
                                                         </div>
                                                      </div>

                                                   </>
                                                )
                                             }

                                             {

                                                selectedTransaction?.order_type === "requirement" && (
                                                   <>
                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Requirement Id</p>
                                                            <p className="text-start ">{selectedTransaction?.jobDetails?._id} </p>
                                                         </div>
                                                      </div>

                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Vacancy Count</p>
                                                            <p className="text-start "> {selectedTransaction?.jobDetails?.vacancy_count} </p>
                                                         </div>
                                                      </div>

                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Hiring Type</p>
                                                            <p className="text-start ">{selectedTransaction?.jobDetails?.hiring_type?.join(", ")} </p>
                                                         </div>
                                                      </div>

                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Salary Offered</p>
                                                            <p className="text-start ">{selectedTransaction?.jobDetails?.salary_offered} </p>
                                                         </div>
                                                      </div>


                                                   </>
                                                )
                                             }

                                             {
                                                isMembershipOrSubscription && (
                                                   <>
                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">{selectedTransaction?.order_type === "membership" ? "Membership" : "Subscription"} Id:</p>
                                                            <p className="text-start ">{selectedTransaction?.membershipAndSubscriptionsDetails?._id} </p>
                                                         </div>
                                                      </div>

                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Is Active:</p>
                                                            <p className="text-start ">{selectedTransaction?.membershipAndSubscriptionsDetails?.is_active ? "Active" : "In-Active"} </p>
                                                         </div>
                                                      </div>

                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">{selectedTransaction?.order_type === "membership" ? "Membership" : "Subscription"} Expiry:</p>
                                                            <p className="text-start ">{`${membershipExpiry?.formattedDate}, ${membershipExpiry?.formattedHours}`} </p>
                                                         </div>
                                                      </div>

                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Worker ID :</p>
                                                            <p className="text-start ">{selectedTransaction?.workerDetails?._id} </p>
                                                         </div>
                                                      </div>

                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1">Worker Name :</p>
                                                            <p className="text-start ">{selectedTransaction?.workerDetails?.name} </p>
                                                         </div>
                                                      </div>

                                                      <div className="col-sm-6 col-lg-4">
                                                         <div className="mb-3 ">
                                                            <p className="text-dark text-start font-weight-normal mb-1"> Worker Phone :</p>
                                                            <p className="text-start ">{selectedTransaction?.workerDetails?.phone} </p>
                                                         </div>
                                                      </div>
                                                   </>
                                                )
                                             }
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              : ""
                        }

                        {
                           (selectedTransaction?.order_type === "doorstep_service" || selectedTransaction?.order_type === "requirement") ?
                              <div className="col-lg-6 p-2">
                                 <div className="card  mb-0">
                                    <div className="card-header text-start" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                       <h5 className="mb-0">
                                          User Details
                                       </h5>
                                    </div>
                                    <div className="card-body">
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">User ID : </span>
                                          <span className="text-start">{selectedTransaction?.user_id ?? "NA"} </span>
                                       </div>
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Name : </span>
                                          <span className="text-start">{selectedTransaction?.userDetails?.name ?? "NA"} </span>
                                       </div>
                                       <div className=" d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Phone : </span>
                                          <span className="text-start">
                                             {selectedTransaction?.userDetails?.phone ?? "NA"} </span>
                                       </div>

                                    </div>
                                 </div>
                              </div> :
                              ""
                        }

                        {
                           selectedTransaction?.order_type !== "requirement" && !isMembershipOrSubscription && selectedTransaction?.doorstepOrderDetails?.status !== "pending" ?
                              <div className="col-lg-6 p-2">
                                 <div className="card  mb-0">
                                    <div className="card-header text-start" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                       <h5 className="mb-0">
                                          Worker Details
                                       </h5>
                                    </div>
                                    <div className="card-body">
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Worker ID : </span>
                                          <span className="text-start">
                                             {
                                                selectedTransaction?.order_type === "doorstep_service" ?
                                                   selectedTransaction?.doorstepOrderDetails?.workerDetails?._id :
                                                   selectedTransaction?.workerDetails?._id ?? "NA"
                                             }

                                          </span>
                                       </div>
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Name : </span>
                                          <span className="text-start">
                                             {
                                                selectedTransaction?.order_type === "doorstep_service" ?
                                                   selectedTransaction?.doorstepOrderDetails?.workerDetails?.name :
                                                   selectedTransaction?.workerDetails?.name ?? "NA"
                                             }

                                          </span>
                                       </div>
                                       <div className=" d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Phone : </span>
                                          <span className="text-start">
                                             {
                                                selectedTransaction?.order_type === "doorstep_service" ?
                                                   selectedTransaction?.doorstepOrderDetails?.workerDetails?.phone :
                                                   selectedTransaction?.workerDetails?.phone ?? "NA"
                                             }

                                          </span>
                                       </div>


                                    </div>
                                 </div>
                              </div> : ''
                        }
                        {
                           selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL1 ?
                              <div className="col-lg-6 p-2">
                                 <div className="card  mb-0">
                                    <div className="card-header d-flex justify-content-between text-start" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                       <h5 className="mb-0">
                                          Sales Details (L1)
                                       </h5>
                                       <div className='d-flex justify-content-end'>
                                          <Link to={`/workers/${selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL1?._id}`}
                                             style={{ pointerEvents: "auto" }}>
                                             <button
                                                className={`py-2 px-3 text-dark font-weight-normal hover-effect`}>
                                                View Profile
                                             </button>
                                          </Link>

                                       </div>
                                    </div>
                                    <div className="card-body">
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          {/* <span className="text-dark text-start font-weight-bold  ">Image: </span> */}
                                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                             <img
                                                src={
                                                   selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL1?.profile_pic
                                                      ? typeof selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL1.profile_pic === 'string'
                                                         ? selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL1.profile_pic
                                                         : URL.createObjectURL(selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL1.profile_pic)
                                                      : undefined
                                                }
                                                alt=""
                                             />
                                          </div>

                                       </div>
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Sales ID: </span>
                                          <span className="text-start">{selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL1?._id ?? "NA"} </span>
                                       </div>
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Name: </span>
                                          <span className="text-start">{selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL1?.name ?? "NA"} </span>
                                       </div>
                                       <div className=" d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Phone: </span>
                                          <span className="text-start">
                                             {selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL1?.phone ?? "NA"} </span>
                                       </div>
                                       <div className=" d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Sub Type: </span>
                                          <span className="text-start">
                                             {selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL1?.sub_worker_type[0] ?? "NA"} </span>
                                       </div>
                                    </div>
                                 </div>
                              </div> : ''
                        }

                        {
                           selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL2 ?
                              <div className="col-lg-6 p-2">
                                 <div className="card  mb-0">
                                    <div className="card-header d-flex justify-content-between text-start" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                       <h5 className="mb-0">
                                          Sales Details (L2)
                                       </h5>
                                       <div className='d-flex justify-content-end'>
                                          <Link to={`/workers/${selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL2?._id}`}
                                             style={{ pointerEvents: "auto" }}>
                                             <button
                                                className={`py-2 px-3 text-dark font-weight-normal hover-effect`}>
                                                View Profile
                                             </button>
                                          </Link>
                                       </div>
                                    </div>
                                    <div className="card-body">
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          {/* <span className="text-dark text-start font-weight-bold  ">Image: </span> */}
                                          <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                             <img
                                                src={
                                                   selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL2?.profile_pic
                                                      ? typeof selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL2.profile_pic === 'string'
                                                         ? selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL2.profile_pic
                                                         : URL.createObjectURL(selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL2.profile_pic)
                                                      : undefined
                                                }
                                                alt=""
                                             />
                                          </div>

                                       </div>
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Sales ID: </span>
                                          <span className="text-start">{selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL2?._id ?? "NA"} </span>
                                       </div>
                                       <div className="d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Name: </span>
                                          <span className="text-start">{selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL2?.name ?? "NA"} </span>
                                       </div>
                                       <div className=" d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Phone: </span>
                                          <span className="text-start">
                                             {selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL2?.phone ?? "NA"} </span>
                                       </div>
                                       <div className=" d-flex align-items-center p-2 gap-3">
                                          <span className="text-dark text-start font-weight-bold  ">Sub Type: </span>
                                          <span className="text-start">
                                             {selectedTransaction?.membershipAndSubscriptionsDetails?.SalesProfessionalL2?.sub_worker_type[0] ?? "NA"} </span>
                                       </div>
                                    </div>
                                 </div>
                              </div> : ""
                        }


                     </div>
                  </div>

               </div>
            </div>

         </div>

      </MainLayout>
   )

};



export default TransactionDetailsPage;